import { useMemo } from "react";
import { IComponentType, IComponentUnion, IFaceLandmarkGroup, ISceneComp, ITrackingTypes } from "../component-data-structure";
import { getScreenRelativeComponentIds } from "../utils/general";


export const getFaceLandmarkIdsBySceneId = (sceneId: string, componentsById: {[id: string]: IComponentUnion}): string[] => {
	const activeSceneChildren = (componentsById[sceneId] as ISceneComp)?.children || [];
    return activeSceneChildren.filter(id => componentsById[id].type === IComponentType.FaceLandmarkGroup);
}

export const useGetScreenRelativeComponentIds = (sceneId: string, componentsById: {[id: string]: IComponentUnion} | null): string[] => {
    return useMemo(() => {
        return getScreenRelativeComponentIds(sceneId, componentsById)
    }, [componentsById, sceneId])
}

export const useGetFaceTrackedComponentIds = (sceneId: string, componentsById: {[id: string]: IComponentUnion} | null): string[] => {
    return useMemo(() => {
        return getFaceTrackedComponentIds(sceneId, componentsById);
    }, [componentsById, sceneId])
}

export const getFaceTrackedComponentIds = (sceneId: string, componentsById: { [id: string]: IComponentUnion } | null): string[] => {
    if (!componentsById) return [];
    if ((componentsById[sceneId] as ISceneComp).trackingType !== ITrackingTypes.face) return [];
    const faceLandmarkIds = getFaceLandmarkIdsBySceneId(sceneId, componentsById);
    return faceLandmarkIds.reduce((acc, landmarkId) => {
        const landmarkGroup = (componentsById[landmarkId] as IFaceLandmarkGroup);
        return [...acc, ...landmarkGroup.children];
    }, [] as string[]);
}